import { useServicesChartsDataContext } from './useServicesChartsDataContext';

export const useCompareFinancingTypes = () => {
    const { chartData } = useServicesChartsDataContext();

    const series = chartData.types?.map((item) => {
        return item.services;
    });

    return {
        values: series,
        subtitles: chartData.types?.map((item, index) => item.description || `Tipo ${index + 1}`),
    };
};
